import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import PEILogo from '@nv/images/logos/pei/pei-logo'
import { useTranslation } from 'react-i18next'

export const EligibilityInfo = () => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(<PEILogo />)
    setBtns([{ text: t('buttons.ok'), onClick: onClose, variant: 'secondary' }])
  }, [])

  return (
    <>
      <h2>{t('registration.disclaimer.eligibility')}:</h2>
      <span>{t('registration.disclaimer.youAreEligibleToVote')}</span>

      <h3>{t('registration.disclaimer.psbE')}</h3>
      <ul>
        <li>{t('registration.disclaimer.yearsOfAge')}</li>
        <li>{t('registration.disclaimer.canadianCitizenOn')}</li>
        <li>{t('registration.disclaimer.livingInPEISince')}</li>
        <li>{t('registration.disclaimer.livingInElectoral')}</li>
      </ul>

      <h3>{t('registration.disclaimer.frenchLanguageSchoolBoard')}</h3>
      <ul>
        <li>{t('registration.disclaimer.yearsOfAge')}</li>
        <li>{t('registration.disclaimer.canadianCitizenOn')}</li>
        <li>{t('registration.disclaimer.livingInPEISince')}</li>
        <li>{t('registration.disclaimer.livingInElectoralCSLF')}</li>
        <li>
          {t('registration.disclaimer.elibigleParent')}{' '}
          <a href='https://www.justice.gc.ca/eng/csj-sjc/rfc-dlc/ccrf-ccdl/check/art23.html' target='_blank' rel='noreferrer'>
            (https://www.justice.gc.ca/eng/csj-sjc/rfc-dlc/ccrf-ccdl/check/art23.html)
          </a>
        </li>
      </ul>
    </>
  )
}
